// components
import { ListSubheader } from '@material-ui/core';

// styles
import { styled } from 'styles/utils';

export const PermissionsCategoryName = styled(ListSubheader)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(18),
}));
